import { useCallback, useEffect, useState } from "react";
import { api } from "../../../lib/api";
import { useAuth } from "../../../providers/AuthProvider";

export type InventoryEntryListItem = {
  id: string;
  business_id: string;
  dealer_id: string;
  reference_no: string;
  total_amount: string;
  batch_ids: string[];
  created_at: string | null;
};

export function useInventoryEntries() {
  const { token } = useAuth();
  const [rows, setRows] = useState<InventoryEntryListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!token) {
      setRows([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await api.inventory.list({ token });
      setRows(res.data);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Failed to load inventory entries");
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { entries: rows, allEntries: rows, loading, error, reload };
}

